export default "__VITE_ASSET__BEVJnKhb__"